import { render, staticRenderFns } from "./PersonalizedGameEditorElement.vue?vue&type=template&id=06e63ac4&scoped=true&"
import script from "./PersonalizedGameEditorElement.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e63ac4",
  null
  
)

export default component.exports